module.exports = "query GetCountries {\n  countries\n}\n"